// Arabic (ar). Keyed by the English source string.
//
// NOT YET REVIEWED by an Arabic speaker -- see locales/index.js. Load it with
// ?lang=ar to read it in place; it is not offered to users until reviewed.
//
// This catalog also exists to exercise RIGHT-TO-LEFT: 'ar' is in RTL_LANGUAGES,
// so selecting it sets dir="rtl" on the document and the layout has to hold up.
// Reviewing the layout is worth doing even before the words are reviewed --
// they are separate problems, and the layout one is the one a Spanish speaker
// cannot find for us.
//
// Notes for whoever reviews it: Lumi is a brand name and stays in Latin script.
// Modern Standard Arabic throughout rather than any dialect, since the audience
// is not regional.
export default {
  // ---- Landing ----
  'Light up a conversation': 'أضئ محادثة',
  'Free, anonymous video, audio and text chat. Meet someone new one to one, or open a room and bring your friends.':
    'محادثة مجانية ومجهولة بالفيديو والصوت والنص. قابل شخصًا جديدًا وجهًا لوجه، أو افتح غرفة وادعُ أصدقاءك.',
  'Name (optional)': 'الاسم (اختياري)',
  'Optional: what should people call you?': 'اختياري: بماذا تحب أن يناديك الآخرون؟',
  'Interests (optional)': 'الاهتمامات (اختياري)',
  'Optional: interests (e.g. music, hiking, anime)': 'اختياري: الاهتمامات (مثل الموسيقى، المشي، الأنمي)',
  'Birth year': 'سنة الميلاد',
  'Select year': 'اختر السنة',
  'How do you want to chat?': 'كيف تريد أن تتحدث؟',
  Camera: 'الكاميرا',
  'Ready to Chat': 'جاهز للمحادثة',
  'Group rooms': 'الغرف الجماعية',
  'Ten minutes': 'عشر دقائق',
  'A chat with a gentle end, with people who chose it too.': 'محادثة تنتهي بهدوء، مع أشخاص اختاروها أيضًا.',
  About: 'حول',
  Regulars: 'المعتادون',
  'Your regulars': 'المعتادون لديك',
  'Watch together': 'المشاهدة معًا',
  'You are invited to a group room': 'أنت مدعو إلى غرفة جماعية',
  'You are invited to a community.': 'أنت مدعو إلى مجتمع.',
  ' Verify your age to ask to join. Its host lets people in when they see the request.':
    ' تحقق من عمرك لطلب الانضمام. يسمح المضيف بالدخول عندما يرى الطلب.',

  // ---- Chat ----
  Chat: 'المحادثة',
  'Say something nice...': 'قل شيئًا لطيفًا...',
  'Finding someone new...': 'جارٍ البحث عن شخص جديد...',
  'Show my camera': 'إظهار كاميرتي',
  'Cameras open when you both tap Show my camera': 'تُفتح الكاميرات عندما يضغط كلاكما على إظهار كاميرتي',
  'Open your camera to them. It opens once they have done the same.':
    'افتح كاميرتك له. ستُفتح عندما يفعل هو الشيء نفسه.',
  'Skip to the next person': 'الانتقال إلى الشخص التالي',
  'Leave the chat and go back to the homepage': 'مغادرة المحادثة والعودة إلى الصفحة الرئيسية',
  'Report this person': 'الإبلاغ عن هذا الشخص',
  Report: 'إبلاغ',
  Wave: 'تحية',
  'Wave at the person you just talked to': 'حيِّ الشخص الذي تحدثت إليه للتو',
  'Go back to that person': 'العودة إلى ذلك الشخص',
  'Send an image': 'إرسال صورة',
  'Share a photo, video, or audio file': 'شارك صورة أو مقطع فيديو أو ملفًا صوتيًا',
  'Report this file to the Lumi team': 'الإبلاغ عن هذا الملف إلى فريق Lumi',
  Remove: 'إزالة',
  'Remove this person for 15 minutes (moderator)': 'إزالة هذا الشخص لمدة 15 دقيقة (مشرف)',
  'You removed this.': 'لقد أزلت هذا.',
  'Take this off your screen': 'إزالة هذا من شاشتك',
  'Cancel reply': 'إلغاء الرد',
  'A question, if you want one: ': 'سؤال، إن أردت: ',
  'Dismiss this question': 'تجاهل هذا السؤال',
  'Double-tap to show the chat and controls': 'اضغط مرتين لإظهار المحادثة وأدوات التحكم',
  'Not now': 'ليس الآن',
  'Lumi Staff': 'فريق Lumi',
  'LUMI STAFF': 'فريق LUMI',
  'Verified Lumi staff': 'فريق Lumi موثّق',
  Moderator: 'مشرف',
  'Verified moderator': 'مشرف موثّق',
  'Lumi Plus member': 'عضو Lumi Plus',
  'Explicit: off': 'المحتوى الصريح: مُعطّل',
  'Explicit chat (18+)': 'محادثة صريحة (+18)',
  'Match me only with adults who chose this too. It changes who you meet next, not this chat, and you both still have to agree once you are in one.':
    'طابقني فقط مع بالغين اختاروا هذا أيضًا. يغيّر ذلك من ستقابله لاحقًا، لا هذه المحادثة، وعليكما الموافقة معًا عند بدئها.',

  // ---- Rooms and communities ----
  ' here': ' هنا',
  '<- Back': '-> رجوع',
  'A community': 'مجتمع',
  'A community is one private room somebody keeps for people they have invited. Lumi stores who is in it and the sessions planned, nothing else.':
    'المجتمع هو غرفة خاصة واحدة يبقيها صاحبها مفتوحة لمن دعاهم. تحفظ Lumi من فيه والجلسات المقررة فقط، ولا شيء غير ذلك.',
  'A community: a private room its host keeps open for invited members':
    'مجتمع: غرفة خاصة يبقيها مضيفها مفتوحة للأعضاء المدعوين',
  'A shared timer everyone in the room can see': 'مؤقت مشترك يراه كل من في الغرفة',
  Accept: 'قبول',
  Activities: 'الأنشطة',
  'Add session': 'إضافة جلسة',
  'Add to calendar': 'إضافة إلى التقويم',
  'Always open': 'مفتوحة دائمًا',
  'Anyone with the link can verify their age and ask to join. You decide who gets in.':
    'يمكن لأي شخص لديه الرابط أن يتحقق من عمره ويطلب الانضمام. أنت من يقرر من يدخل.',
  'Ask one person who is waiting if they would like to join for ten minutes':
    'اسأل شخصًا ينتظر إن كان يود الانضمام لعشر دقائق',
  'Ask to chat one-on-one': 'اطلب محادثة ثنائية',
  'Asked to join': 'طلب الانضمام',
  'Audio room': 'غرفة صوتية',
  Browse: 'تصفح',
  Close: 'إغلاق',
  'Communities you are in': 'المجتمعات التي تنتمي إليها',
  Community: 'مجتمع',
  'Copy Lumi Link': 'نسخ Lumi Link',
  'Copy my Lumi Link': 'نسخ Lumi Link الخاص بي',
  'Copy the Lumi Link for this room': 'انسخ Lumi Link لهذه الغرفة',
  Create: 'إنشاء',
  'Create one and it will show up here for everyone in your age group.':
    'أنشئ واحدة وستظهر هنا لكل من في فئتك العمرية.',
  'Create room': 'إنشاء غرفة',
  Decline: 'رفض',
  Delete: 'حذف',
  'Download an .ics file for this session': 'تنزيل ملف ‎.ics‎ لهذه الجلسة',
  'Drop in': 'مرور سريع',
  'Every live room': 'كل الغرف النشطة',
  'Every week': 'كل أسبوع',
  Generate: 'توليد',
  'Go 1:1': 'الانتقال إلى محادثة ثنائية',
  'Has hosted rooms people came to': 'استضاف غرفًا حضر إليها الناس',
  'Has not said anything yet': 'لم يقل شيئًا بعد',
  'Have a code?': 'لديك رمز؟',
  'Hide this person: no video, audio, texts, or files from them, and they cannot ask you to go 1:1':
    'إخفاء هذا الشخص: لا فيديو ولا صوت ولا رسائل ولا ملفات منه، ولا يمكنه طلب محادثة ثنائية معك',
  'Hides it here for now. They are not told, and they can still be accepted later.':
    'يخفيه هنا مؤقتًا. لا يُبلَّغ بذلك، ويمكن قبوله لاحقًا.',
  Ignore: 'تجاهل',
  'Invite a regular...': 'ادعُ أحد المعتادين...',
  'Invite someone in': 'ادعُ شخصًا',
  Join: 'انضمام',
  'Join as Lumi Staff: you will be visible to the room, wearing the staff badge':
    'انضم بصفتك فريق Lumi: ستكون ظاهرًا للغرفة، بشارة الفريق',
  'Jump in': 'ادخل الآن',
  Kick: 'طرد',
  Leave: 'مغادرة',
  'Leave and block': 'مغادرة وحظر',
  'Leave, and block the host: you stop being regulars and they cannot invite you again. They are not told.':
    'غادر واحظر المضيف: لن تبقيا معتادَين ولن يستطيع دعوتك مرة أخرى. لا يُبلَّغ بذلك.',
  'Loading...': 'جارٍ التحميل...',
  'Lumi keeps the name, the code, who is in, and the sessions. Not the conversation.':
    'تحفظ Lumi الاسم والرمز ومن بالداخل والجلسات. لا تحفظ المحادثة.',
  MOD: 'مشرف',
  Members: 'الأعضاء',
  'Message the room...': 'اكتب إلى الغرفة...',
  Mute: 'كتم',
  'My community': 'مجتمعي',
  'New messages': 'رسائل جديدة',
  'No live rooms right now.': 'لا توجد غرف نشطة الآن.',
  'No public rooms right now': 'لا توجد غرف عامة الآن',
  'No session planned.': 'لا توجد جلسة مقررة.',
  'Nobody owns these and they never close. Walk in, listen for a while, and say something when you feel like it.':
    'هذه الغرف لا يملكها أحد ولا تُغلق أبدًا. ادخل، واستمع قليلًا، وقل شيئًا حين تشاء.',
  'Nobody yet. Invite a regular, or share your Lumi Link.': 'لا أحد بعد. ادعُ أحد المعتادين أو شارك Lumi Link الخاص بك.',
  Once: 'مرة واحدة',
  Open: 'فتح',
  'Out of the community: they cannot come back unless you invite them again':
    'خارج المجتمع: لا يمكنه العودة ما لم تدعُه مجددًا',
  'Out of the room for 15 minutes; still a member': 'خارج الغرفة 15 دقيقة؛ ولا يزال عضوًا',
  PRO: 'PRO',
  'People on camera, out of the camera slots this room has':
    'عدد من فتحوا الكاميرا، من أصل أماكن الكاميرا في هذه الغرفة',
  'Pin this for everyone in the room': 'ثبّت هذا لكل من في الغرفة',
  Private: 'خاصة',
  'Public rooms': 'الغرف العامة',
  Refresh: 'تحديث',
  Rename: 'إعادة التسمية',
  'Room Pro: the larger room': 'Room Pro: الغرفة الأكبر',
  'Room chat': 'محادثة الغرفة',
  'Room code': 'رمز الغرفة',
  'Room name': 'اسم الغرفة',
  'Room rules': 'قواعد الغرفة',
  'Rooms that are always open': 'غرف مفتوحة دائمًا',
  'Say hi, I have been lurking': 'ألقِ التحية، كنت أتابع بصمت',
  See: 'عرض',
  Send: 'إرسال',
  Sessions: 'الجلسات',
  'Share a file': 'مشاركة ملف',
  'Sit down to work with a shared timer:': 'اجلس للعمل مع مؤقت مشترك:',
  'Something to do together': 'شيء تفعلونه معًا',
  Start: 'ابدأ',
  'Start a chat once and Lumi will remember you on this device; then a community can too.':
    'تحدث مرة واحدة وستتذكرك Lumi على هذا الجهاز؛ وعندها يمكن للمجتمع أن يتذكرك أيضًا.',
  'Start a community': 'أنشئ مجتمعًا',
  'Start a room': 'أنشئ غرفة',
  'Start my community': 'أنشئ مجتمعي',
  'Started this room': 'أنشأ هذه الغرفة',
  'Straight into one': 'مباشرة إلى واحدة',
  'Suggest a name nobody is using': 'اقترح اسمًا لا يستخدمه أحد',
  'Take the invitation back': 'سحب الدعوة',
  'Talk with a few people at once. Start your own, or drop into one that is already going.':
    'تحدث مع عدة أشخاص في وقت واحد. أنشئ غرفتك أو مُر على غرفة قائمة.',
  'Text room': 'غرفة نصية',
  'The language this room is for': 'لغة هذه الغرفة',
  'They leave the room and cannot come back unless you invite them again':
    'يغادر الغرفة ولا يمكنه العودة ما لم تدعُه مجددًا',
  'Times are in your clock. Members see it inside the room and get a reminder ten minutes before, if they are on Lumi then.':
    'الأوقات بحسب ساعتك. يراها الأعضاء داخل الغرفة ويصلهم تذكير قبل عشر دقائق، إن كانوا على Lumi حينها.',
  'Try again': 'حاول مرة أخرى',
  'Video room': 'غرفة فيديو',
  'Vote: go private': 'صوّت: اجعلها خاصة',
  Waiting: 'في الانتظار',
  'We will find a room of that kind with space in it.': 'سنجد غرفة من ذلك النوع فيها متسع.',
  'What are you doing?': 'ماذا تفعلون؟',
  'What is it? e.g. Film night': 'ما هي؟ مثل: ليلة أفلام',
  'Who is in this room': 'من في هذه الغرفة',
  Withdraw: 'سحب',
  Yes: 'نعم',
  'You can enter any room here, including private ones and the minors band.':
    'يمكنك دخول أي غرفة هنا، بما فيها الخاصة وفئة القاصرين.',
  'You can invite your regulars once you have some: wave after a chat, and if they wave back, they are here to pick.':
    'يمكنك دعوة معتاديك حين يصبح لديك بعضهم: حيِّ بعد محادثة، وإن ردّ التحية ظهر هنا لتختاره.',
  'You muted this person': 'لقد كتمت هذا الشخص',
  'Your community': 'مجتمعك',
  'Your community code': 'رمز مجتمعك',
  'Your status': 'حالتك',
  Yours: 'مجتمعك',
  'e.g. Late Night Lounge': 'مثل: صالة ما بعد منتصف الليل',
  'e.g. Tuesday book club': 'مثل: نادي كتاب الثلاثاء',

  // ---- Account, Plus, support, activities, media controls ----
  ' I have written it down or saved it': ' دوّنته أو حفظته',
  '(no drawing arrived, so describe what you imagine)': '(لم يصل أي رسم، فصِف ما تتخيله)',
  '(nothing arrived in time)': '(لم يصل شيء في الوقت المحدد)',
  '+30s': '+30 ث',
  'A concern, a bug or a question. It goes straight to the Lumi team. Replies appear here; keep the page open.':
    'ملاحظة أو خلل أو سؤال. يصل مباشرة إلى فريق Lumi. تظهر الردود هنا؛ أبقِ الصفحة مفتوحة.',
  'A plausible answer': 'إجابة مقنعة',
  'A regular is someone you have both waved at after a chat. Lumi keeps the two of you, the names you saw, the date, and any messages you send each other for thirty days. Nothing else: no history, and never where anyone was.':
    'المعتاد هو شخص حيّا كلٌّ منكما الآخر بعد محادثة. تحفظ Lumi اسميكما اللذين رأيتماهما والتاريخ والرسائل بينكما لمدة ثلاثين يومًا. لا شيء غير ذلك: لا سجل، ولا أين كان أحد قط.',
  'A reviewer would like a brief live camera check to confirm your age. Tap Start when you are ready: they can see and talk to you until the check is decided.':
    'يريد المراجع فحصًا مباشرًا قصيرًا بالكاميرا لتأكيد عمرك. اضغط ابدأ عندما تكون جاهزًا: يمكنه رؤيتك والتحدث إليك حتى يُبتّ في الفحص.',
  'A sentence somebody could draw': 'جملة يمكن لأحدهم رسمها',
  'A short tone when someone joins a room, when a regular is around, when a call comes in, and when a message arrives while you are looking elsewhere.':
    'نغمة قصيرة عند انضمام أحد إلى غرفة، وعند وجود أحد المعتادين، وعند ورود مكالمة، وعند وصول رسالة بينما تنظر إلى مكان آخر.',
  'Add to queue': 'أضف إلى قائمة التشغيل',
  'Amount (USD)': 'المبلغ (دولار)',
  'An account is optional. Lumi works without one. Signing in only remembers your name, your Plus membership, and anything you have unlocked.':
    'الحساب اختياري. تعمل Lumi بدونه. تسجيل الدخول يحفظ اسمك وعضوية Plus وما فتحته فقط.',
  'Asking...': 'جارٍ السؤال...',
  Back: 'رجوع',
  'Back ten seconds, for everyone': 'عشر ثوانٍ إلى الوراء، للجميع',
  'Back to Lumi': 'العودة إلى Lumi',
  'Back to sign in': 'العودة إلى تسجيل الدخول',
  'Back to start': 'العودة إلى البداية',
  'Background blur': 'تمويه الخلفية',
  Block: 'حظر',
  Call: 'اتصال',
  Cancel: 'إلغاء',
  'Chat text size': 'حجم نص المحادثة',
  'Chat with an Admin': 'التحدث إلى مسؤول',
  Clear: 'مسح',
  Continue: 'متابعة',
  'Continue without sound': 'المتابعة بدون صوت',
  Cool: 'بارد',
  Copy: 'نسخ',
  'Cosmetics shop': 'متجر المظاهر',
  'Create account': 'إنشاء حساب',
  'Delete this message for everyone': 'حذف هذه الرسالة للجميع',
  'Delete this message for you': 'حذف هذه الرسالة لك وحدك',
  'Describe the drawing in a sentence': 'صِف الرسم بجملة واحدة',
  'Dismiss this notice': 'تجاهل هذا الإشعار',
  Donate: 'تبرّع',
  'Draw and guess': 'ارسم وخمّن',
  'Draw this': 'ارسم هذا',
  Dream: 'حلم',
  'Each round one person sees the marker and gives one clue. Everyone else guesses where it sits.':
    'في كل جولة يرى شخص واحد العلامة ويعطي دليلًا واحدًا. ويخمّن الباقون أين تقع.',
  'Earlier messages': 'رسائل سابقة',
  'Eighty seconds a drawing. Three points for the first right guess, then two, then one, and one to the drawer each time.':
    'ثمانون ثانية لكل رسم. ثلاث نقاط لأول تخمين صحيح، ثم نقطتان، ثم نقطة، ونقطة للرسّام في كل مرة.',
  'End the shared video for everyone': 'إنهاء الفيديو المشترك للجميع',
  'End this activity for everyone': 'إنهاء هذا النشاط للجميع',
  Eraser: 'ممحاة',
  'Everyone answers, out loud or in the chat. No vote on this one.':
    'يجيب الجميع، بصوت عالٍ أو في المحادثة. لا تصويت في هذه.',
  'Everyone writes a sentence. Each is handed on to be drawn, then described, then drawn again, round the table. Then the album.':
    'يكتب كل شخص جملة. تُمرَّر لتُرسم، ثم تُوصف، ثم تُرسم من جديد، دورة كاملة. ثم يأتي الألبوم.',
  FAQ: 'الأسئلة الشائعة',
  Filter: 'مُرشّح',
  'Final scores': 'النتائج النهائية',
  'Forget me on this device': 'انسَني على هذا الجهاز',
  'Forgot your password?': 'نسيت كلمة المرور؟',
  From: 'من',
  'Get Lumi Plus': 'احصل على Lumi Plus',
  'Getting your camera ready...': 'جارٍ تجهيز كاميرتك...',
  'Go Plus monthly': 'Plus شهريًا',
  'Go Plus yearly': 'Plus سنويًا',
  'Handed in. Waiting for the others.': 'تم التسليم. في انتظار الآخرين.',
  'If you have lost the code as well, an admin can look at it.':
    'إن فقدت الرمز أيضًا، يمكن لمسؤول أن ينظر في الأمر.',
  'Insert an emoji': 'إدراج رمز تعبيري',
  Invisible: 'غير مرئي',
  'Join them': 'انضم إليه',
  'Keep an independent, ad-free, privacy-first service alive. Thank you.':
    'أبقِ خدمة مستقلة بلا إعلانات تضع الخصوصية أولًا على قيد الحياة. شكرًا لك.',
  'Larger chat text': 'نص أكبر',
  'Line this up to play after what is on now': 'ضعه في الدور ليُشغَّل بعد ما يعمل الآن',
  'Live check requested': 'طُلب فحص مباشر',
  'Live: ten questions, fifteen seconds each. Fake answer: write something plausible, then vote; you score for finding the truth and for fooling people.':
    'مباشر: عشرة أسئلة، خمس عشرة ثانية لكل سؤال. الإجابة المزيفة: اكتب شيئًا مقنعًا ثم صوّت؛ تكسب نقاطًا لإيجاد الحقيقة ولخداع الآخرين.',
  'Load and watch': 'تحميل ومشاهدة',
  'Lumi Plus and more': 'Lumi Plus وأكثر',
  'Lumi admin': 'مسؤول Lumi',
  'Lumi is free and ad-free. Upgrades are optional and 18+ only. Under-18 accounts cannot be created.':
    'Lumi مجانية وبلا إعلانات. الترقيات اختيارية ولمن هم فوق 18 فقط. لا يمكن إنشاء حسابات لمن هم دون 18.',
  'Lumi remembers you on this device with a random key, so regulars and rooms can find you again. It holds no name and no personal details, and it is deleted after 90 days away.':
    'تتذكرك Lumi على هذا الجهاز بمفتاح عشوائي، حتى يجدك المعتادون والغرف مرة أخرى. لا يحمل اسمًا ولا أي تفاصيل شخصية، ويُحذف بعد 90 يومًا من الغياب.',
  'Make it sound true. Nobody sees who wrote what until the end.':
    'اجعلها تبدو صحيحة. لا أحد يرى من كتب ماذا حتى النهاية.',
  'Message deleted': 'حُذفت الرسالة',
  'Message from the review team': 'رسالة من فريق المراجعة',
  'Messages here go only to Lumi administrators. A live voice/video chat starts only if you tap Start.':
    'ما تكتبه هنا يصل إلى مسؤولي Lumi فقط. ولا تبدأ محادثة صوتية أو مرئية مباشرة إلا إذا ضغطت ابدأ.',
  Mono: 'أحادي',
  Monthly: 'شهريًا',
  'More than half of the people here can skip what is on':
    'يمكن لأكثر من نصف الموجودين هنا تخطي ما يُعرض',
  'New password (8+ characters)': 'كلمة مرور جديدة (8 أحرف فأكثر)',
  'Nice!': 'جميل!',
  'No answer.': 'لا إجابة.',
  'No filter': 'بدون مُرشّح',
  'No points yet.': 'لا نقاط بعد.',
  'No regulars yet.': 'لا معتادين بعد.',
  'No thanks': 'لا، شكرًا',
  'Noise suppression': 'كتم الضوضاء',
  'Not open yet': 'غير متاح بعد',
  'Not open yet. ': 'غير متاح بعد. ',
  'Nothing is remembered on this device yet.': 'لا شيء محفوظ على هذا الجهاز بعد.',
  'One clue, a word or two': 'دليل واحد، كلمة أو كلمتان',
  'One of these is true. Which?': 'إحداها صحيحة. أيها؟',
  'One person tells three things about themselves, two true and one made up. Everyone else votes for the lie.':
    'يقول شخص ثلاثة أشياء عن نفسه، اثنان صحيحان وواحد مختلق. ويصوّت الباقون على الكذبة.',
  'Only you can see the marker. Say one thing that sits about here.':
    'أنت وحدك ترى العلامة. قل شيئًا يقع هنا تقريبًا.',
  'Password (8+ characters)': 'كلمة المرور (8 أحرف فأكثر)',
  'Paste a link': 'الصق رابطًا',
  'People you have both waved at after a chat. You stay anonymous to each other.':
    'أشخاص حيّا كلٌّ منكما الآخر بعد محادثة. تبقيان مجهولَين لبعضكما.',
  'Pick up': 'رد',
  'Plus is not on sale yet: these are the planned prices. Lumi is free and complete without it, and your account is ready for the day it opens.':
    'Plus ليست معروضة للبيع بعد: هذه هي الأسعار المقررة. Lumi مجانية وكاملة بدونها، وحسابك جاهز ليوم إتاحتها.',
  Points: 'النقاط',
  'Priority matching, higher video quality, and exclusive cosmetics are now yours. Enjoy!':
    'المطابقة ذات الأولوية وجودة الفيديو الأعلى والمظاهر الحصرية صارت لك. استمتع!',
  'Priority queue, a higher video bitrate, cosmetic flair, and a Plus mark. No ads, no data sale, ever.':
    'أولوية في الطابور، وجودة فيديو أعلى، ولمسات مظهرية، وشارة Plus. بلا إعلانات وبلا بيع بيانات، أبدًا.',
  'Question cards': 'بطاقات الأسئلة',
  'Quiet hours': 'ساعات الهدوء',
  React: 'تفاعل',
  'React to this message': 'تفاعل مع هذه الرسالة',
  Ready: 'جاهز',
  'Recovery code from signup': 'رمز الاسترداد من التسجيل',
  'Remove them from your regulars. They are not told.':
    'أزِله من معتاديك. لا يُبلَّغ بذلك.',
  Reply: 'رد',
  'Reply to this message': 'الرد على هذه الرسالة',
  'Report this message to the Lumi team': 'الإبلاغ عن هذه الرسالة إلى فريق Lumi',
  'Report to an admin': 'إبلاغ مسؤول',
  'Ringing...': 'جارٍ الرنين...',
  'Room Pro': 'Room Pro',
  Scores: 'النتائج',
  'Send to an admin': 'إرسال إلى مسؤول',
  'Set a new password': 'تعيين كلمة مرور جديدة',
  Settings: 'الإعدادات',
  'Sign in': 'تسجيل الدخول',
  'Sign in or create an account (18+) to go Plus, upgrade a room, or grab cosmetics. Lumi stays free either way.':
    'سجّل الدخول أو أنشئ حسابًا (+18) للحصول على Plus أو ترقية غرفة أو اقتناء المظاهر. تبقى Lumi مجانية في الحالتين.',
  'Sign out': 'تسجيل الخروج',
  'Signing in is instant. Creating an account is 18+ and includes a quick age check.':
    'تسجيل الدخول فوري. إنشاء حساب لمن هم فوق 18 ويتضمن فحص عمر سريعًا.',
  'Skip forward thirty seconds, for everyone': 'ثلاثون ثانية إلى الأمام، للجميع',
  'Smaller chat text': 'نص أصغر',
  'Something drawable: one or two things, one action, one twist.':
    'شيء قابل للرسم: شيء أو شيئان، فعل واحد، ومفاجأة.',
  Sounds: 'الأصوات',
  Spectrum: 'المقياس',
  'Start live chat': 'بدء المحادثة المباشرة',
  'Start live check': 'بدء الفحص المباشر',
  Stop: 'إيقاف',
  'Support Lumi': 'ادعم Lumi',
  Telephone: 'الهاتف',
  Text: 'نص',
  'The admin wants to talk live': 'يريد المسؤول التحدث مباشرة',
  'The code you were given when you created the account.':
    'الرمز الذي أُعطي لك عند إنشاء الحساب.',
  'The game is under way.': 'اللعبة جارية.',
  'The word was': 'كانت الكلمة',
  'They are not free right now.': 'ليس متاحًا الآن.',
  'They did not pick up.': 'لم يرد.',
  'This device': 'هذا الجهاز',
  'This game runs inside a Lumi room.': 'تُلعب هذه اللعبة داخل غرفة Lumi.',
  'This will not play here': 'لا يمكن تشغيل هذا هنا',
  Trivia: 'مسابقة معلومات',
  'Turn on camera': 'تشغيل الكاميرا',
  'Turn on microphone': 'تشغيل الميكروفون',
  'Two ways to play': 'طريقتان للعب',
  'Type a message...': 'اكتب رسالة...',
  'Type your reply...': 'اكتب ردك...',
  'Unpin it': 'إلغاء التثبيت',
  'Upgrade room': 'ترقية الغرفة',
  'Use your recovery code': 'استخدم رمز الاسترداد',
  Username: 'اسم المستخدم',
  'Vanity code (e.g. LOUNGE)': 'رمز مخصص (مثل LOUNGE)',
  'Verifying your age': 'جارٍ التحقق من عمرك',
  Video: 'فيديو',
  Voice: 'صوت',
  'Voice and video, so you can talk directly. Nothing starts until you tap.':
    'صوت وفيديو، لتتحدث مباشرة. لا يبدأ شيء حتى تضغط.',
  'Waiting for the room...': 'في انتظار الغرفة...',
  Warm: 'دافئ',
  'What is this?': 'ما هذا؟',
  'What would you like to tell us?': 'ماذا تود أن تخبرنا؟',
  'When a chat ends you can wave. If the other person waves too, within seven days, you become regulars: you see each other here, and which public room the other is in. Nobody is told about a wave that was not returned.':
    'عند انتهاء المحادثة يمكنك التحية. وإن حيّاك الطرف الآخر أيضًا خلال سبعة أيام، تصبحان معتادَين: ترى كل منكما الآخر هنا، وفي أي غرفة عامة هو. ولا يُبلَّغ أحد بتحية لم تُردّ.',
  'Whether everyone may play and pause. Seeking and stopping stay yours either way.':
    'ما إذا كان بإمكان الجميع التشغيل والإيقاف المؤقت. أما التنقل والإيقاف فيبقيان لك في الحالتين.',
  Whiteboard: 'السبورة',
  'Who is playing': 'من يلعب',
  'Would you rather...': 'أيهما تفضل...',
  'Write a message': 'اكتب رسالة',
  'Write a sentence': 'اكتب جملة',
  'Write this down before you continue': 'دوّن هذا قبل أن تتابع',
  Yearly: 'سنويًا',
  'You are a Plus member. Thank you for keeping Lumi independent and ad-free.':
    'أنت عضو Plus. شكرًا لإبقائك Lumi مستقلة وبلا إعلانات.',
  'You got it! Watch the others try.': 'أصبت! شاهد محاولات الآخرين.',
  'You have been given Lumi Plus!': 'لقد مُنحت Lumi Plus!',
  'You joined after it started, so you get to watch the album at the end.':
    'انضممت بعد البداية، لذا ستشاهد الألبوم في النهاية.',
  'Your Lumi account': 'حسابك في Lumi',
  'Your answer is in.': 'وصلت إجابتك.',
  'Your guess': 'تخمينك',
  'Your microphone level (scaled by the volume slider)':
    'مستوى الميكروفون لديك (يتغير حسب شريط الصوت)',
  'Your regulars will not see which room you are in, or that you are here at all.':
    'لن يرى معتادوك في أي غرفة أنت، ولا حتى أنك هنا.',
  'Your turn to draw. Pick a word:': 'دورك في الرسم. اختر كلمة:',
  'Your turn: give one clue': 'دورك: أعطِ دليلًا واحدًا',
  // A brand name: the same in every language. Listed so it reads as a
  // decision rather than a gap in the catalog.
  'Lumi Plus': 'Lumi Plus',
  'Audio': 'صوت',
  'Opens when we both agree': 'تُفتح عندما نوافق كلانا',
  'Opens from the start': 'مفتوحة من البداية',
  'Your account': 'حسابك',
  'Sign in or create an account': 'سجّل الدخول أو أنشئ حسابًا',
  'Create account (18+)': 'إنشاء حساب (+18)',
  'Regulars ({n})': 'المعتادون ({n})',
};
